import { render } from "./MsExcel.vue?vue&type=template&id=ebc1e88c&scoped=true"
import script from "./MsExcel.vue?vue&type=script&lang=js"
export * from "./MsExcel.vue?vue&type=script&lang=js"

import "./MsExcel.vue?vue&type=style&index=0&id=ebc1e88c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc1e88c"]])

export default __exports__